import { Dispatch, SetStateAction, memo, useEffect, useState } from 'react'
import FilterComponent from '../../../components/common/FilterComponent'
import { getCPCustomerFilterData } from '../../../queries/ScenarioForecast'
import useFilter from '../../../hooks/useFilter'
import FilterComponentCreator from '../../../components/common/FilterComponent/FilterComponentCreator'
import { SummaryFilterConfig } from './SummaryFilterConfig'

type Props = {
    handleSummaryFilterValueChange: Dispatch<SetStateAction<SummaryAndDetialFilterSelectedValues>>;
    summaryAndDetailsFilterValues: SummaryAndDetialFilterSelectedValues,
    setLoading: Dispatch<SetStateAction<number>>
    baseFilterValues: BaseCustomerPortabilityFilterValues;
    handelBaseFilterValueChange: Dispatch<SetStateAction<BaseCustomerPortabilityFilterValues>>;
}

const projectTypeDropDown: SelectDropDown[] = [
    {
        label: "Project",
        value: "Project"
    },
    {
        label: "Non Project",
        value: "NonProject"
    }
]
const SummaryFilter = ({ handleSummaryFilterValueChange, handelBaseFilterValueChange, summaryAndDetailsFilterValues, setLoading, baseFilterValues }: Props) => {
    const [filterData, setFilterData] = useState({});
    const { selectedFilter } = useFilter()
    useEffect(() => {
        (async () => {
            const data = await getSummaryFIlterData({})
            if (!data) return
            if (selectedFilter == "electrical") {
                handleFilterValueChange("district", data.district[0].District)
                handleFilterValueChange("date", data.date[0].date)
            }
        })()
    }, []);

    const getSummaryFIlterData = async (filterValues: any) => {
        setLoading((prev) => prev + 1)
        if (selectedFilter == "electrical" && !filterValues.projectFlag) {
            filterValues.projectFlag = "All"
        }
        try {
            const response = await getCPCustomerFilterData(filterValues, selectedFilter);
            if (!response.data) return
            if (selectedFilter == "electrical")
                response.data.project = projectTypeDropDown
            setFilterData(response.data);
            return response.data
        }
        catch (err) {
            console.log("Error fetching Summary filters:", err)
            throw err
        }
        finally {
            setLoading((prev) => prev - 1)
        }
    };

    const handleFilterValueChange = (
        key: string,
        value: string | string[],
        callFilterApi: boolean = true
    ) => {
        const baseFilter: (keyof BaseCustomerPortabilityFilterValues)[] = ["customer", "district", "project"]
        if (baseFilter.includes(key as (keyof BaseCustomerPortabilityFilterValues)))
            handelBaseFilterValueChange((prev) => ({ ...prev, [key]: value }));
        else
            handleSummaryFilterValueChange((prev) => ({ ...prev, [key]: value }));
        if (callFilterApi)
            getSummaryFIlterData({ ...summaryAndDetailsFilterValues, ...baseFilterValues, [key]: value })

    };
    return (
        <>
            <FilterComponentCreator config={SummaryFilterConfig[selectedFilter]} data={filterData} handleFilterValueChange={handleFilterValueChange} values={{ ...summaryAndDetailsFilterValues, ...baseFilterValues }} />
        </>
    )
}

export default memo(SummaryFilter)